<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'bestof.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="bestofGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'bestofGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'state': {
          type: 'number'
        },
        'ym_start': {
          type: 'number'
        },
        'ym_end': {
          type: 'number'
        }
      },
      preload: [{
        field: 'prodaggreg_id',
        api: 'prodaggregs/lst'
      }],
      url: 'bestof/campaigns',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '100px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'state',
        title: 'Estado',
        values: lists.states,
        width: '120px'
      },
      {
        field: 'ym_start',
        title: 'Inicio',
        width: '120px'
      },
      {
        field: 'ym_end',
        title: 'Fim',
        width: '120px'
      },
      {
        field: 'enable_value',
        title: 'Valor',
        values: lists.states,
        width: '120px'
      },
      {
        field: 'enable_operators',
        title: 'Operadores',
        values: lists.states,
        width: '120px'
      },
      {
        field: 'enable_quantity',
        title: 'Quantidade',
        values: lists.states,
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'bestof.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('bestof.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
